import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { selectedConversationAtom } from '../../../../atoms/v3/chatAtoms';
import { IOSHeader } from '../ios/IOSHeader';
import { IOSHeaderActions } from '../ios/IOSHeaderActions';
import { ChatMoreOptions } from './ChatMoreOptions';
import { ChatHeaderTitle } from './ChatHeaderTitle';
import { NewChatButton } from './NewChatButton';
import { CharacterAvatar } from './CharacterAvatar';

interface ChatHeaderProps {
  isEmbedded?: boolean;
}

/**
 * 聊天页面的顶部导航栏组件
 * 包含返回按钮、标题、角色选择器和更多操作按钮
 * 所有交互逻辑内聚在组件内部
 */
export const ChatHeader: React.FC<ChatHeaderProps> = ({ isEmbedded = false }) => {
  const { t } = useTranslation(['v3/chat']);
  const selectedConversation = useAtomValue(selectedConversationAtom);

  const title = selectedConversation?.title || t('v3/chat:newChat')

  // 所有点击处理逻辑已移至各自组件内部实现

  return (
    <IOSHeader
      isEmbedded={isEmbedded}
      left={
        <div className="flex items-center space-x-3">
          <CharacterAvatar />
          <ChatHeaderTitle title={title} />
        </div>
      }
      center={null}
      right={
        <IOSHeaderActions>
          <ChatMoreOptions/>
          <NewChatButton />
        </IOSHeaderActions>
      }
    />
  );
};
